import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SEO from '../components/SEO';

const DatenschutzPage = () => {
  return (
    <div className="pt-20 pb-16 min-h-screen bg-white">
      <SEO
        title="Datenschutzerklärung"
        description="Datenschutzerklärung der LAIzyones. Informationen zur Verarbeitung personenbezogener Daten gemäß DSGVO."
        path="/datenschutz"
        breadcrumbs={[
          { name: 'Startseite', url: '/' },
          { name: 'Datenschutz' },
        ]}
      />
      <div className="container-custom max-w-3xl">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-emerald-600 transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" /> Zurück zur Startseite
        </Link>

        <h1 className="heading-xl text-3xl md:text-4xl text-gray-900 mb-10">Datenschutzerklärung</h1>

        <div className="prose prose-gray max-w-none
          [&_h2]:font-['Space_Grotesk'] [&_h2]:font-semibold [&_h2]:text-xl [&_h2]:text-gray-900 [&_h2]:mt-10 [&_h2]:mb-3
          [&_h3]:font-['Space_Grotesk'] [&_h3]:font-semibold [&_h3]:text-lg [&_h3]:text-gray-900 [&_h3]:mt-8 [&_h3]:mb-3
          [&_p]:text-gray-600 [&_p]:leading-relaxed [&_p]:mb-3
          [&_ul]:text-gray-600 [&_ul]:pl-5 [&_ul]:mb-3 [&_ul]:space-y-1
          [&_li]:text-gray-600
          [&_a]:text-emerald-600 [&_a]:no-underline hover:[&_a]:underline
        ">
          <h3>1. Allgemeine Hinweise</h3>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir verarbeiten
            personenbezogene Daten ausschließlich im Einklang mit der Datenschutz-Grundverordnung
            (DSGVO) sowie den geltenden nationalen Datenschutzbestimmungen.
          </p>

          <h3>2. Verantwortlicher für die Datenverarbeitung</h3>
          <p>
            <strong className="text-gray-900">Laizyones</strong><br />
            Einzelunternehmen
          </p>
          <p>
            Inhaber: David Ehrle<br />
            Ferdinand-Lentjes-Straße 32<br />
            39167 Wellen<br />
            Deutschland
          </p>
          <p>
            Telefon: 0172 1771141<br />
            E-Mail: <a href="mailto:info@laizyones.de">info@laizyones.de</a>
          </p>

          <h3>3. Erhebung von Daten beim Besuch der Website</h3>
          <p>
            Beim Aufrufen unserer Website werden automatisch Informationen durch den Webserver
            erfasst. Dazu gehören unter anderem:
          </p>
          <ul>
            <li>IP-Adresse</li>
            <li>Datum und Uhrzeit der Anfrage</li>
            <li>Browsertyp</li>
            <li>Betriebssystem</li>
            <li>Referrer-URL</li>
          </ul>
          <p>
            Diese Daten dienen ausschließlich der Sicherstellung eines stabilen und sicheren
            Betriebs der Website.
          </p>

          <h3>4. Kontaktaufnahme</h3>
          <p>
            Wenn Sie uns per E-Mail oder über ein Kontaktformular kontaktieren, werden Ihre
            Angaben zur Bearbeitung Ihrer Anfrage gespeichert.
          </p>

          <h3>5. Einsatz von Cookies</h3>
          <p>
            Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem
            Endgerät gespeichert werden.
          </p>
          <p>Wir unterscheiden folgende Cookie-Kategorien:</p>
          <ul>
            <li><strong className="text-gray-900">Technisch notwendige Cookies:</strong> Diese Cookies sind für die Grundfunktionen der Website erforderlich und werden automatisch gesetzt. Sie können nicht deaktiviert werden. (Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO)</li>
            <li><strong className="text-gray-900">Analyse-Cookies:</strong> Diese Cookies helfen uns zu verstehen, wie Besucher die Website nutzen. Sie werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt. (Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO)</li>
            <li><strong className="text-gray-900">Marketing-Cookies:</strong> Diese Cookies ermöglichen personalisierte Inhalte und werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt. (Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO)</li>
          </ul>
          <p>
            Beim ersten Besuch unserer Website wird ein Cookie-Consent-Banner angezeigt, über das Sie
            Ihre Einwilligung zur Nutzung bestimmter Cookies geben oder verweigern können. Ihre Wahl wird lokal
            in Ihrem Browser gespeichert. Sie können Ihre Cookie-Einstellungen jederzeit ändern, indem Sie die
            gespeicherten Daten in Ihrem Browser löschen. Die Verarbeitung
            erfolgt gemäß DSGVO und TTDSG.
          </p>

          <h3>5a. Widerruf der Cookie-Einwilligung</h3>
          <p>
            Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
            Löschen Sie dazu einfach die gespeicherten Cookie-Daten in Ihren Browser-Einstellungen.
            Beim nächsten Besuch unserer Website wird das Cookie-Banner erneut angezeigt.
          </p>

          <h3>6. Einsatz von KI-Technologien</h3>
          <p>
            Im Rahmen unserer Dienstleistungen nutzt Laizyones Technologien im Bereich
            künstliche Intelligenz zur Analyse und Optimierung von Geschäftsprozessen. Dabei
            wird darauf geachtet, dass alle datenschutzrechtlichen Anforderungen eingehalten werden.
          </p>

          <h3>6a. Datenverarbeitung bei LAIzyleads</h3>
          <p>
            LAIzyleads ist eine KI-gestützte Plattform zur B2B-Leadgenerierung. Bei der Nutzung
            von LAIzyleads werden folgende Daten verarbeitet:
          </p>
          <ul>
            <li>Vom Nutzer eingegebene Suchkriterien und Filtereinstellungen</li>
            <li>Generierte Lead-Daten (öffentlich verfügbare Unternehmensinformationen)</li>
            <li>Nutzungsdaten zur Verbesserung des Dienstes</li>
          </ul>
          <p>
            <strong className="text-gray-900">Keine Weitergabe an Dritte:</strong> Die über LAIzyleads verarbeiteten Daten und
            Suchergebnisse werden wissentlich nicht an Dritte weitergegeben. Die Verarbeitung
            erfolgt ausschließlich zur Erbringung des vereinbarten Dienstes.
          </p>
          <p>
            Extrahierte Lead-Daten basieren auf öffentlich zugänglichen Quellen. Laizyones
            speichert diese Daten nur im Rahmen der aktiven Nutzung durch den Kunden.
          </p>

          <h3>6b. Datenverarbeitung bei LAIzyblueprint</h3>
          <p>
            LAIzyblueprint ist eine KI-gestützte Anwendung zur Erstellung von
            Leistungsverzeichnissen aus Grundrissen. Bei der Nutzung werden folgende Daten
            verarbeitet:
          </p>
          <ul>
            <li>Vom Nutzer hochgeladene Grundrisse und Baupläne</li>
            <li>Bearbeitungen und Anpassungen des Nutzers</li>
            <li>Generierte Leistungsverzeichnisse und Berechnungen</li>
            <li>Nutzungsdaten zur Verbesserung des Dienstes</li>
          </ul>
          <p>
            <strong className="text-gray-900">Keine Weitergabe an Dritte:</strong> Hochgeladene Grundrisse, Bearbeitungen und
            generierte Leistungsverzeichnisse werden wissentlich nicht an Dritte
            weitergegeben. Die Verarbeitung erfolgt ausschließlich zur Erbringung des
            vereinbarten Dienstes und zur Generierung der vom Nutzer angeforderten Ergebnisse.
          </p>
          <p>
            Der Nutzer hat jederzeit die Möglichkeit, seine hochgeladenen Daten und erstellten
            Leistungsverzeichnisse zu löschen.
          </p>

          <h3>7. Weitergabe von Daten</h3>
          <p>Eine Weitergabe Ihrer Daten erfolgt nur:</p>
          <ul>
            <li>wenn dies zur Vertragserfüllung erforderlich ist</li>
            <li>wenn eine gesetzliche Verpflichtung besteht</li>
            <li>wenn Sie ausdrücklich eingewilligt haben</li>
          </ul>

          <h3>8. Speicherdauer</h3>
          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie dies für den jeweiligen
            Zweck erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.
          </p>

          <h3>9. Rechte der betroffenen Personen</h3>
          <p>Sie haben jederzeit das Recht auf:</p>
          <ul>
            <li>Auskunft über Ihre gespeicherten Daten</li>
            <li>Berichtigung unrichtiger Daten</li>
            <li>Löschung Ihrer Daten</li>
            <li>Einschränkung der Verarbeitung</li>
            <li>Datenübertragbarkeit</li>
            <li>Widerruf einer Einwilligung</li>
          </ul>

          <h3>10. Beschwerderecht</h3>
          <p>
            Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde über die Verarbeitung
            Ihrer personenbezogenen Daten zu beschweren.
          </p>

          <h3>11. Änderung dieser Datenschutzerklärung</h3>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung bei Änderungen der Website oder
            gesetzlicher Vorgaben anzupassen.
          </p>
        </div>
      </div>
    </div>
  );
};

export default DatenschutzPage;
